import {makeStyles} from '@material-ui/core/styles'

export const useGreyClasses = makeStyles({
  root: {
    color: '#8F8C89',
  },
})

export const useButtonClasses = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0.5, 0),
    },
  },
}))

export const useDialogActionsClasses = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: 0,
      marginTop: theme.spacing(2.5),
    },
  },
  spacing: {
    [theme.breakpoints.down('sm')]: {
      '& > :not(:first-child)': {
        marginLeft: 0,
      },
    },
  },
}))
